import { useState } from "react";


const useLoading = () => {

  const [loading, setLoading] = useState<boolean>(false);

  const alterLoading = () => setLoading((value) => !value);

  const stopLoading = () => setLoading(false);

  const startLoading = () => setLoading(true);

  return {
    startLoading,
    stopLoading,
    alterLoading,
    isLoading: loading
  };
}

export default useLoading;
